module.exports = __webpack_public_path__ + "3a8b64dd3dd6e14d5a4c12d7e16a6ed0.png";